const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const convertToBoolean = require('../../../../helpers/convertToBoolean');

const TOOLTIP = 'Allows a message to be displayed when a user clicks this button';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);

    line1OfInputs
        .appendField('  Message:')
        .appendField(new Blockly.FieldTextInput(), 'message')
        .appendField('  Display Title:')
        .appendField(new Blockly.FieldCheckbox(), 'displayTitle')
        .appendField('  Start With Message Displayed:')
        .appendField(new Blockly.FieldCheckbox(), 'defaultOpen')
        .appendField('  Preview Message:')
        .appendField(new Blockly.FieldCheckbox(), 'preview')
        .appendField('  Button Style If Unopened:')
        .appendField(new Blockly.FieldTextInput('warn'), 'buttonStyleIfUnopened')
        .appendField('  Button Style If Opened:')
        .appendField(new Blockly.FieldTextInput('transparent'), 'buttonStyleIfOpened')
        .appendField('  Icon Name:')
        .appendField(new Blockly.FieldTextInput('info'), 'iconName');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);

    addCodeProperties([
        'message',
        { key: 'displayTitle', handler: convertToBoolean },
        { key: 'defaultOpen', handler: convertToBoolean },
        { key: 'preview', handler: convertToBoolean },
        { key: 'buttonStyleIfUnopened', value: 'warn' },
        { key: 'buttonStyleIfOpened', value: 'transparent' },
        // doesn't exist for InfoDisplayButton
        { key: 'forAction', handler: () => undefined },
        { key: 'namespace', handler: () => undefined },
        { key: 'relation', handler: () => undefined }
    ]);

    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
